const zipCodeOptionalCountries = ['IE'];

const noZipCodeCountries = ['HK', 'AE', 'MO'];

export const hideZipCode = (countyCode) => noZipCodeCountries.indexOf(countyCode) !== -1;

export const isZipCodeOptional = (countryCode) =>
  zipCodeOptionalCountries.indexOf(countryCode) !== -1;
